export function useFetchToc(legalTextSlug: MaybeRef<string | undefined>) {
  const enabled = computed(() => Boolean(toValue(legalTextSlug)));
  const query = useQuery({
    ...queries().legalTexts.bySlug(legalTextSlug)._ctx.tableOfContents,
    enabled,
    shallow: true,
  });

  return { query, enabled };
}
